import querystring from 'querystring';

import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import ProgressiveImage from 'react-progressive-image';

import defaultPicturePlaceholder from '../../assets/img/default_pictures/default_no_picture.png';

const defaultReSharperBaseUri = 'https://re-sharper.digitregroup.io/';

const ReSharperImg = props => {
  const [forcePlaceholder, setForcePlaceholder] = useState(false);

  const resharperQueryParams = {
    img: props.url,
    q: props.q,
    h: props.h,
    w: props.w,
    fit: props.fit,
    pos: props.pos,
    grav: props.grav,
    strat: props.strat,
  };

  let resharperUrl = defaultReSharperBaseUri + '?' + querystring.encode(resharperQueryParams);

  if (forcePlaceholder) {
    resharperUrl = props.placeholder;
  }

  return (
    <ProgressiveImage
      src={resharperUrl}
      placeholder={props.placeholder}
      onError={e => {
        console.warn('Error from ReSharperImg: ', e);
        setForcePlaceholder(true);
      }}
    >
      {(src, loading) => {
        const style = {
          opacity: loading ? 0.5 : 1,
          backgroundImage: `url(${src})`,
          backgroundSize: 'cover',
          backgroundPosition: '50% 50%',
          width: props.w || props.style.width || props.style.maxWidth || '100%',
          height: props.w || props.style.height || props.style.maxHeight || '100%',
          flex: 'none',
          ...props.style,
        };

        if (loading === true) {
          return (
            <div className={props.className}>
              <Skeleton height={props.w || style.height} width={props.w || style.width} />
            </div>
          );
        }

        return (
          <div style={style} className={props.className} alt={props.alt} title={props.title} onClick={props.onClick} />
        );
      }}
    </ProgressiveImage>
  );
};

ReSharperImg.propTypes = {
  url: PropTypes.string.isRequired, // [required] The base image that will be processed.
  q: PropTypes.number, // The JPEG output quality, between 1 and 100. Defaults to 80.
  h: PropTypes.number, // The height of the output.
  w: PropTypes.number, // The width of the output.
  fit: PropTypes.oneOf(['cover', 'contain', 'fill', 'inside', 'outside']), // The type of resizing.
  pos: PropTypes.string, // The position of the picture in the output.
  grav: PropTypes.string, // The gravity applied to the picture in input.
  strat: PropTypes.string, // The strategy to use when fit is cover.
  placeholder: PropTypes.string, // Placeholder Img
  className: PropTypes.string, // Img className
  alt: PropTypes.string, // Img alt
  title: PropTypes.string, // Img title
  onClick: PropTypes.func, // Img onClick
  style: PropTypes.object, // Img style
};

ReSharperImg.defaultProps = {
  className: 'd-block',
  placeholder: defaultPicturePlaceholder,
  alt: 'Aperçu',
  title: '',
  style: {},
};

export default ReSharperImg;
